class SB
{
    static get(url, token)
    {
        var promise = new Promise(function(resolve, reject)
        {
            let req = new XMLHttpRequest();
            req.open("GET", url);
        
            SB._ajaxHandle(req, token, resolve, reject);
 
            req.send();
        });

    /*
        promise.catch(function(error)
        {
            alert(error.message);
        });
    */

        return promise;
    }

    static post(url, data, token)
    {
        var promise = new Promise(function(resolve, reject)
        {
            let req = new XMLHttpRequest();
            req.open("POST", url);
 
            SB._ajaxHandle(req, token, resolve, reject);
 
            var formData;
            if (data instanceof HTMLFormElement) {
                formData = new FormData(data);
            } else if (data instanceof Object) {
                formData = new FormData();
                Object.keys(data).forEach(key => formData.append(key, data[key]));
            } else {
                formData = data;
            }

           // req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
 
            req.send(formData);
        });

    /*
        promise.catch(function(error)
        {
            alert(error.message);
        });
    */

        return promise;

    }

    static _ajaxHandle(req, token, resolve, reject)
    {
        if (token) {
            token.abort = function()
            {
                req.abort();
                reject(new AbortError());
            };
        }

        req.onload = function()
        {
            var type = req.getResponseHeader('content-type');

            var data = null;
            if (type == "application/json") {
                try {
                    data = JSON.parse(req.responseText);
                    
                    if (data.type == "error") {
                        reject(new Error(data.message));
                        return;
                    }

                } catch (e) {
                    e.message = "Invalid data returned from server";
                    reject(e);
                    return;
                }
            } else {
               // data = req.responseText;
                reject(new Error(req.responseText));
                return;
            }

            if (req.status === 200) {
                resolve(data);
            } else {
                reject(new Error(req.statusText));
            }
        };
 
        req.onerror = function()
        {
            reject(new Error("Error connecting to server"));
        };
    }
}


// custom error handler for abort error
function AbortError(message) {
  this.name = 'AbortError';
  this.message = message || 'Action aborted';
  this.stack = (new Error()).stack;
}
AbortError.prototype = Object.create(Error.prototype);
AbortError.prototype.constructor = AbortError;


/*
class AbortError extends Error {
  constructor(message) {
    super(message);
    this.name = 'AbortError';
  }
}
*/
